<app-base-alert-dialog (Close)="closeAlert">
  <ng-container id="header">
    <mat-icon class="error-icon">error_outline</mat-icon>
    {{title}}
  </ng-container>
  <ng-container id="content">
    {{message}}
  </ng-container>
</app-base-alert-dialog>
